module.exports = __webpack_public_path__ + "img/rosepetal-dep-carnesselectas.a1af6807.jpg";